module.exports = __webpack_public_path__ + "static/media/AAN4_EDITSINGLE.437f308d.mp4";